import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';
import { twMerge } from 'tailwind-merge';
import App from './ui/App';
import { PrimeReactTailwindThemes } from './constants';
import { store, persistor } from '@/store';
import { setupSpeechPolyfill } from '@/speech/setupSpeechPolyfill';
import { applyStoredTextPreferences } from './ui/theme/textPreferences';

setupSpeechPolyfill();
applyStoredTextPreferences();
import './index.css';
import 'primeicons/primeicons.css';
// Only downloaded once the OpenDyslexic font preference is in use.
import '@fontsource/opendyslexic/400.css';
import '@fontsource/opendyslexic/400-italic.css';
import '@fontsource/opendyslexic/700.css';
import '@fontsource/opendyslexic/700-italic.css';
import { GlobalToastInitializer, GlobalToastProvider } from '@repo/atomic-components';
import { ColourThemeProvider } from './ui/theme/ColourThemeContext';
import { SettingsHubProvider } from './ui/components/SettingsHub';
import { PersistGate } from 'redux-persist/integration/react';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PrimeReactProvider
          value={{
            unstyled: true,
            // @ts-expect-error PrimeReact internal types problem
            pt: PrimeReactTailwindThemes,
            ptOptions: {
              mergeSections: true,
              mergeProps: true,
              classNameMergeFunction: twMerge,
            },
          }}
        >
          <BrowserRouter>
            <GlobalToastProvider maxToasts={3}>
              <GlobalToastInitializer />
              <ColourThemeProvider>
                {/* Inside the router and the theme provider: the hub's controls navigate and
                    read the current theme. Above <App /> so the modal outlives route changes. */}
                <SettingsHubProvider>
                  <App />
                </SettingsHubProvider>
              </ColourThemeProvider>
            </GlobalToastProvider>
          </BrowserRouter>
        </PrimeReactProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
